const numberOfSnippets = (snippets) => (!snippets?.length ? 0 : snippets.length);

const sortSnippets = (snippets, caseTypeId) => {
  if (snippets) {
    let global = [];
    let advisor = [];
    let account = [];
    snippets.forEach((snippet) => {
      let snippetObj = {
        key: snippet.id,
        text: snippet.description,
        content: snippet.content,
        accountId: snippet?.accountId,
        caseTypeId: caseTypeId,
      };

      if (snippet.userId) {
        return advisor.push(snippetObj);
      } else if (snippet.accountId) {
        return account.push(snippetObj);
      } else {
        return global.push(snippetObj);
      }
    });

    return { global, advisor, account };
  }
};

const replaceImgTagsWithWarningMessage = (snippet) => {
  const warningMsg =
    "<div style='border: 3px dotted #ECECEC;'><h3 style='color: #a49f9f; text-align: center;'>Images cannot be previewed</h3></div>";
  return snippet ? snippet.replace(/<img[^>]*>/gi, warningMsg) : <></>;
};

export { numberOfSnippets, sortSnippets, replaceImgTagsWithWarningMessage };
